import { render, staticRenderFns } from "./PurchaseOrdersDashboard.vue?vue&type=template&id=a7597956&scoped=true&"
import script from "./PurchaseOrdersDashboard.vue?vue&type=script&lang=js&"
export * from "./PurchaseOrdersDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7597956",
  null
  
)

export default component.exports